import { ICheckbox } from './checkbox.model';
import { ITrigger } from './trigger.model';
import { SortDirection } from '@angular/material/sort';
import { Button } from './button.model';
import { IInfoSelect, ISelect } from './select.model';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

export enum ETableColumnType {
  TEXT = 'text',
  BUTTON = 'button',
  SELECT = 'select',
  TRIGGER = 'trigger',
  COMPONENT = 'component',
  CHECKBOX = 'checkbox',
  ANCHOR = 'anchor',
}

export interface IComponentProperties {
  component: any;
  mapData: {
    [key: string]: {
      instance: 'self' | 'column' | 'static' | 'function';
      target?: any;
    };
  };
}

export enum EFilterColumnTypes {
  SELECT = 'select',
}

export interface ITableColumn<T> {
  id: string;
  type?: ETableColumnType;
  buttonProperties?: Button;
  getButtonProperties?: (element: any) => Button;
  selectProperties?: ISelect<T> | IInfoSelect;
  getSelectProperties?: (element: any) => ISelect<T> | IInfoSelect;
  triggerProperties?: ITrigger;
  componentProperties?: IComponentProperties;
  checkboxProperties?: ICheckbox;
  filterColumnType?: EFilterColumnTypes;
  title?: string;
  sortable?: boolean;
  total?: boolean;
  defaultSorted?: boolean;
  select?: boolean;
  isExtra?: boolean;
  route?: any;
  class?: any;
  renderer?: (row: T) => string;
  hint?: string;
  dynamicRoute?: boolean;
  asHtml?: boolean;
  headerAsFilter?: boolean;
  headerFilter?: string;
  headerAsPagination?: boolean;
  isDateColumn?: boolean;
  dateFormat?: string;
  emptyValue?: string;
  leftAdjusted?: boolean;
  anchorHandler?: (column: ITableColumn<T>, row: T) => void;
  disabled?: boolean;
  getFaIconPrefix?: (row: T) => IconDefinition | undefined
}

export interface ITableMassiveAction<T> {
  label: string;
  handler: (rows: T[]) => void;
}

export enum EFilterType {
  SELECT = 'select',
  MULTISELECT = 'multiselect',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  TEXT = 'text',
  SEARCH = 'search',
  TAGS = 'tags',
  BUTTON = 'button',
}

export interface ITableFilterItem {
  id: string;
  value?: any;
  label: string;
  icon?: string;
  selected?: boolean;
  resetOtherFilters?: boolean;
}

export interface ITableFIlterGroup {
  filters: ITableFilter[];
  label?: string;
}

export enum EFilterSize {
  FULL = 'full',
  HALF = 'half',
}

export interface ITableFilter {
  type: EFilterType;
  id?: string;
  items?: ITableFilterItem[];
  emptyValue?: string;
  label?: string;
  icon?: string;
  onFilterChange?: (value: any) => void;
  applyFilter?: boolean;
  size?: EFilterSize;
  buttonProperties?: Button;
  hideOnMobile?: boolean;
}

export interface ITableDataSource {
  [key: string]: any;
}

export interface ITable {
  columns: ITableColumn<any>[];
  filters?: ITableFilter[];
  defaultSort: string;
  pageSize: number;
  dataSource: ITableDataSource[];
}

export interface DataSourceParams {
  pageSize?: number;
  page: number;
  params?: { [key: string]: any };
  sortAttr: string;
  sortDir: SortDirection | string;
  filters?: { [key: string]: any };
}

export interface IBaseTableResult<T, R = any> {
  items: T[];
  count: number;
  has_more_data: boolean;
  current_page: number;
  current_page_size: number;
  total_page_count: number;
  total_count: number;
  type?: string;
  extra_data: R;
}
